// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import CloseIcon from '@mui/icons-material/Close'
import ErrorIcon from '@mui/icons-material/Error'
import { IconButton, Snackbar } from '@mui/material'
import React from 'react'
import css from './SnackBar.css'
type Props = {
  message: string
  autoHideDuration?: number
  closeSnackBar: (...args: Array<any>) => any
  showSnackBar: boolean
  vertical?: string
  horizontal?: string
}

const SnackBar = ({
  message,
  autoHideDuration = 3000,
  closeSnackBar,
  showSnackBar,
  vertical = 'bottom',
  horizontal = 'left',
}: Props) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical,
        horizontal,
      }}
      open={showSnackBar}
      autoHideDuration={autoHideDuration}
      onClose={closeSnackBar}
      ContentProps={{
        'aria-describedby': 'message',
      }}
      message={
        <div id='message' className={css.verticalCenter}>
          <ErrorIcon /> {message}
        </div>
      }
      action={[
        <IconButton key='close' aria-label='Close' color='inherit' onClick={closeSnackBar}>
          <CloseIcon />
        </IconButton>,
      ]}
    />
  )
}

export default SnackBar
